/**
 * @description Hook utilizado para manipular os exames de comparação

 * @file useExameComparacaoService.js
 * @license Copyright (c) 2023 SIGEP DIGETI ITEP/RN
 */

const { useFetch } = require('./useFetch')

export const useExameComparacaoService = () => {
  const fetch = useFetch()

  const editarExameComparacao = async (id, valores, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dados = { resultado: valores.resultado }
      await fetch.putOpen(`/exameComparacao/${id}`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRegistrosIdentificacaoExameComparacaoAsync = async (idExame, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameComparacao/registrosIdentificacao/deExame/examinador/${idExame}`)
      return response.data.registrosIdentificacao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarExameComparacaoParaExaminadorAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameComparacao/${id}/examinador/`)
      return response.data.exameComparacao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const confirmarDadosExameComparacao = async (idExame, idPericiando, valores, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)

      const dadosFinalizacao = {
        resultado: valores.resultado,
        registrosIdentificacao: valores.registrosIdentificacao
          ? valores.registrosIdentificacao.map((registro) => ({
              ...registro,
              idPericiando,
              estado: registro.estado?.sigla || null,
              cidade: registro.cidade?.nome || null,
              nacionalidade: registro.nacionalidade?.nome || null,
              filiacoes: registro.filiacoes?.length ? registro.filiacoes.map((filiacao) => filiacao.nome) : null,
            }))
          : null,
      }
      await fetch.putOpen(`/exameComparacao/confirmarDados/${idExame}`, dadosFinalizacao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    editarExameComparacao,
    listarRegistrosIdentificacaoExameComparacaoAsync,
    listarExameComparacaoParaExaminadorAsync,
    confirmarDadosExameComparacao,
  }
}
